<template>
    <Row :gutter="24">
        <template v-for="appProperty in list" :key="appProperty.id">
            <Col :xs="24" :md="9">{{ appProperty.key }}</Col>
            <Col :xs="24" :md="15" class="mb-2">
                <Image
                    v-if="appProperty.propertyType?.type === 'Image'"
                    v-model:value="appProperty.image"
                    @update:value="() => (appProperty.isSave = true)"
                ></Image>
                <Input v-else v-model:value="appProperty.value" @change="() => (appProperty.isSave = true)"></Input>
            </Col>
        </template>
    </Row>
</template>

<script>
import { defineAsyncComponent, defineComponent } from "vue";
import { Row, Col, Input } from "ant-design-vue";

export default defineComponent({
    components: {
        Row,
        Col,
        Input,
        Image: defineAsyncComponent(() => import("../../../../components/input/template-builder/image/Image")),
    },
    props: {
        list: {},
    },
    setup() {
        return {};
    },
});
</script>